RivalIQ.module('postTags.models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const MAX_POST_TAG_LENGTH = 256;
    RivalIQ.postTags.MAX_POST_TAG_LENGTH = MAX_POST_TAG_LENGTH;

    models.PostTag = Backbone.Model.extend({

        validate: function (attrs) {
            return models.PostTag.getTagNameValidationError(_.get(attrs, ['tag_name']));
        },

        urlRoot: function () {
            return `/api/landscape/${RivalIQ.state.landscape.id}/postTags`;
        }
    });

    models.PostTag.getTagNameValidationError = function (tagName) {
        tagName = _.trim(_.toString(tagName));
        if (!tagName) {
            return 'Tag cannot be empty.';
        }
        if (tagName.length > MAX_POST_TAG_LENGTH) {
            return `Tag must be ${MAX_POST_TAG_LENGTH} characters or less.`;
        }
    };

    models.PostTag.isValidTagName = function (tagName) {
        return !models.PostTag.getTagNameValidationError(tagName);
    };
});
